export enum BackHeaderImageType {
  Default = "default",
  Logo = "logo",
  Symbol = "symbol",
  None = "none",
}
